import '../App.scss';
import {BaseContext, isFullAdmin} from '../helpers/common'
import React, {useContext, useEffect, useState} from 'react';
import {Button} from "react-bootstrap";
const _ = require("lodash");

function FacilityComponent(props) {
    const { userInfo } = useContext(BaseContext);
    const [showBanner, setShowBanner] = useState(false);
    const isUserFullAdmin = isFullAdmin(userInfo);
    const bannerClosed = localStorage.getItem('leagueapps_banner_closed') === "true";

    useEffect(() => {
        setShowBanner(isUserFullAdmin && !bannerClosed);
    }, [isUserFullAdmin]);

    const onClose = () => {
        localStorage.setItem("leagueapps_banner_closed", "true");
        setShowBanner(false);
    }

    if (!showBanner) {
        return null;
    }
    return (
        <div className="notice-banner body1">
            <div style={{ flexGrow: 1 }}><strong>RecTimes Has Joined LeagueApps!</strong> We’re excited to bring you even more tools, support, and innovation—while keeping the RecTimes experience you trust. <a href="https://leagueapps.com/media-room/leagueapps-rectimes-acquisition-facility-management">Learn more here!</a></div>
            <Button variant="link" className="nav-link skinny" onClick={onClose}><i className="fa fa-x" /></Button>
        </div>
    );
}

export default FacilityComponent;
